import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet'

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import IntegrationsOverview from '../partials/integrations/IntegrationsOverview'
import IntegrationDetail from '../partials/integrations/IntegrationDetail'
import IntegrationsAdd from '../partials/integrations/IntegrationsAdd'
import AlertModal from '../partials/AlertModal'


import HubSpotIcon from '../images/hubspot.png'
import IntercomIcon from '../images/intercom.png'


import { Auth, API, graphqlOperation } from 'aws-amplify';
import { listEmPushyIntegrations, listActiveIntegrations, listIntegrationOverviews } from '../graphql/queries'

function Integrations() {

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation()
  const history = useHistory()
  const [ userDetails, setUserDetails ] = useState(null)
  const [activeTab, setActiveTab] = useState('overview')
  const [authToken, setAuthToken] = useState(null)
  const [selectedIntegration, setSelectedIntegration] = useState(null)
  const [empushyIntegrations, setEmpushyIntegrations] = useState([])
  const [activeIntegrations, setActiveIntegrations] = useState([])
  const [activeIntegrationsHTML, setActiveIntegrationsHTML] = useState('')
  const [integrationOverviews, setIntegrationOverviews] = useState([])
  const [activityData, setActivityData] = useState({})
  const [analysisData, setAnalysisData] = useState({})
  const [alertModalState, setAlertModalState] = useState(null)
  const [integrationDataLoading, setIntegrationDataLoading] = useState(false)

  useEffect(() => {
    OnLoad();
  }, []);

  function OnLoad() {

    Auth.currentSession().then(response => {
      if(location!=null) {
        if(location.state==null) {
          history.push('/signin')
        }
        else{
          setUserDetails(location.state.userDetails)
          if('queryParams' in location.state) {
            if(location.state.queryParams === 'n=ready')
              setAlertModalState({title: '🎉 Insights Ready', message: 'Insights for your synced integration ✔️ are ready. Check them out now 👀'})
            else if(location.state.queryParams === 'n=nodata')
              setAlertModalState({title: 'No insights for now 🥺', message: 'You haven\'t sent any HubSpot email campaigns yet.' +
                    ' Need inspiration? Check out the Compose feature 👈'})
            else if(location.state.queryParams === 'n=oops')
              setAlertModalState({title: 'Oops 😳', message: 'No insights could be found right now. We\'re workng on it 🔨'})
          }
          setAuthToken(response.idToken.jwtToken)
          fetchData(location.state.userDetails, response.idToken.jwtToken)
        }
      }
      else {
        history.push('/signin')
      }

    }).catch( (error) => {
      history.push('/signin')
    });


  }

  function selectedTab(tabName, activeIntegration){
    if(tabName!=activeTab) {
      setActiveTab(tabName)
    }
    if(activeIntegration!=null) {
      activeIntegration['name'] = tabName
      setSelectedIntegration(activeIntegration)
    }
  }

  const handleIcon = (name) => {
    switch (name) {
      case 'HubSpot':
        return (
          <div>
            <img className="inline cursor-pointer mr-1" src={HubSpotIcon} width="24" height="24"/>
            {name}
          </div>

        );
      case 'Intercom':
        return (
          <div>
            <img className="inline cursor-pointer mr-1" src={IntercomIcon} width="24" height="24"/>
            {name}
          </div>
        );
      default:
        return (
          <svg className="flex-shrink-0 mr-2 sm:mr-3" width="36" height="36" viewBox="0 0 36 36">
            <circle fill="#24292E" cx="18" cy="18" r="18" />
            <path d="M18 10.2c-4.4 0-8 3.6-8 8 0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4V24c-2.2.5-2.7-1-2.7-1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6-.2 1.3-.3 2-.3s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.4.6.9.6 1.6v2.2c0 .2.1.5.6.4 3.2-1.1 5.5-4.1 5.5-7.6-.1-4.4-3.7-8-8.1-8z" fill="#FFF" />
          </svg>
        );
    }
  };

  async function fetchData(user, authToken) {

    var integrations = []
    var activeIntegrations = []
    var overviews = []


    var response = await API.graphql({ query: listEmPushyIntegrations })
    if(response.data.listEmPushyIntegrations!=null) {
      var integrations = response.data.listEmPushyIntegrations.items
      setEmpushyIntegrations(integrations)
      if(integrations.length>0)
        setIntegrationDataLoading(true)
    }

    var filter = {
      clientId: {
        eq: user.clientId // filter priority = 1
      }
    };
    var response = await API.graphql({ query: listActiveIntegrations, variables: { filter: filter} })
    if(response.data.listActiveIntegrations!=null) {
      activeIntegrations = response.data.listActiveIntegrations.items
      setActiveIntegrations(activeIntegrations)
      setActiveIntegrationsHTML(activeIntegrations.map( (item) =>
        <li key={item.integrationId}
          className="pb-3 mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8">
          <button className="text-gray-500 hover:text-gray-600 whitespace-nowrap"
                  onClick={() => {
                    selectedTab(item.integration.name, item)
                  }}><div>{handleIcon(item.integration.name)}</div>
          </button>
        </li>
      ));
    }

    if(activeIntegrations.length>0) {

      for(var activeIntegration of activeIntegrations){
        fetchIntegrationOverviewStats(authToken, activeIntegration, user);
      }
      setActiveTab('overview')
    }
    else
      setActiveTab('add')
  }

  function fetchIntegrationOverviewStats(authToken, activeIntegration, user){
    const apiName = 'DashboardAPI';
    const path = '/integration/query';
    const params = {
      queryStringParameters: {
        integration: activeIntegration.integration.name,
        case: 'overview',
        clientId: user.clientId,
        activeIntegrationId: activeIntegration.id
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {

        if('overview' in response){
          var overview = response['overview']
          overview.name = activeIntegration.integration.name
          overview.activeIntegration = activeIntegration
          setIntegrationOverviews( integrationOverviews => [...integrationOverviews, ...[overview]] )
          setIntegrationDataLoading(false)
        }
        else if(activeIntegration.insightJobPending){
          var overview = { 'name': activeIntegration.integration.name, 'activeIntegration': activeIntegration }
          setIntegrationOverviews( integrationOverviews => [...integrationOverviews, ...[overview]] )
          setIntegrationDataLoading(false)
        }
        else{
          console.log('Overview data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  function loadActivityData(authToken, activeIntegration, user) {

    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'activity-stats',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('activity-stats' in response) {
              setActivityData((prev) => {
                return {...prev, ...response['activity-stats']}
              });
            }
            else{
              console.log('Activity data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'activity-emails',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('activity-emails' in response) {
              setActivityData((prev) => {
                return {...prev, ...response['activity-emails']}
              });
            }
            else{
              console.log('Activity data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'activity-blog',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('activity-blog' in response) {
              setActivityData((prev) => {
                return {...prev, ...response['activity-blog']}
              });
            }
            else{
              console.log('Activity data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'activity-pages',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('activity-pages' in response) {
              setActivityData((prev) => {
                return {...prev, ...response['activity-pages']}
              });
            }
            else{
              console.log('Activity data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  function loadAnalysisData(authToken, activeIntegration, user) {

    if(authToken!=null) {
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'analysis-overview',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async (response) => {
            if (response!==null && 'analysis-overview' in response) {
              setAnalysisData((prev) => {
                return {...prev, ...response['analysis-overview']}
              });
              var market = response['analysis-overview']['marketOverview']['market']
              if(market.length>0){
                var params = {
                  queryStringParameters: {
                    integration: activeIntegration.integration.name,
                    case: 'analysis-recent-market-push',
                    market: market[0]['category'],
                    clientId: user.clientId,
                    activeIntegrationId: activeIntegration.id
                  },
                  headers: {
                    Authorization: `Bearer ${authToken}`
                  },
                };

                API.get(apiName, path, params)
                    .then(async (response) => {
                      if ('analysis-recent-market-push' in response) {
                        setAnalysisData((prev) => {
                          return {...prev, ...response['analysis-recent-market-push']}
                        });

                      } else {
                        console.log('Analysis data not found.')
                      }
                    })
                    .catch(error => {
                      console.log('Error executing request.')
                      console.log(error)
                    });
              }
            } else {
              console.log('Analysis data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'analysis-market-timing',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async (response) => {
            if ('analysis-market-timing' in response) {
              setAnalysisData((prev) => {
                return {...prev, ...response['analysis-market-timing']}
              });
            } else {
              console.log('Analysis data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'analysis-tone',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async (response) => {
            if ('analysis-tone' in response) {
              setAnalysisData((prev) => {
                return {...prev, ...response['analysis-tone']}
              });
            } else {
              console.log('Analysis data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'analysis-cta',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async (response) => {
            if ('analysis-cta' in response) {
              setAnalysisData((prev) => {
                return {...prev, ...response['analysis-cta']}
              });
            } else {
              console.log('Analysis data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'analysis-urgency',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async (response) => {
            if ('analysis-urgency' in response) {
              setAnalysisData((prev) => {
                return {...prev, ...response['analysis-urgency']}
              });
            } else {
              console.log('Analysis data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'analysis-entities',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async (response) => {
            if ('analysis-entities' in response) {
              setAnalysisData((prev) => {
                return {...prev, ...response['analysis-entities']}
              });
            } else {
              console.log('Analysis data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'analysis-topic',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async (response) => {
            if ('analysis-topic' in response) {
              setAnalysisData((prev) => {
                return {...prev, ...response['analysis-topic']}
              });
            } else {
              console.log('Analysis data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

    }
  }

  return userDetails!=null?(
    <div className="flex h-screen overflow-hidden striped-background-pattern">
      {/* Page Title */}
      <Helmet>
        <title>EmPushy | Integrations</title>
      </Helmet>

      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

            {/* Page header */}
            <div className="mb-5">
              {/* Title */}
              <h1 className="text-2xl md:text-3xl text-gray-800 font-bold">Integrations 🔗</h1>
            </div>

            {/* Search form */}
            {/*<div className="max-w-xl mb-5">
              <form className="relative">
                <label htmlFor="app-search" className="sr-only">Search</label>
                <input id="app-search" className="form-input w-full pl-9 py-3 focus:border-gray-300" type="search" placeholder="Search…" />
                <button className="absolute inset-0 right-auto group" type="submit" aria-label="Search">
                  <svg className="w-4 h-4 flex-shrink-0 fill-current text-gray-400 group-hover:text-gray-500 ml-3 mr-2" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
                    <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
                  </svg>
                </button>
              </form>
            </div>*/}

            {/* Filters */}
            <div className="mb-4 border-b border-gray-300">
              <ul className="text-sm font-medium flex flex-nowrap -mx-4 sm:-mx-6 lg:-mx-8 overflow-x-scroll no-scrollbar">
                {activeIntegrations.length>0?<li
                  className="pb-3 mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8">
                  <button className="text-gray-500 hover:text-gray-600 whitespace-nowrap"
                          onClick={() => selectedTab('overview', null)}>📊 Overview
                  </button>
                </li>:''}
                {activeIntegrationsHTML}
                <li className="pb-3 mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8">
                  <button className="text-gray-500 hover:text-gray-600 whitespace-nowrap" onClick={() => selectedTab('add', null)}>⚙️ Sync Settings</button>
                </li>
              </ul>
            </div>

            {/* Page content */}
            {
              activeTab=='overview'?<IntegrationsOverview integrationOverviews={integrationOverviews}
                                                          selectedTab={selectedTab}
                                                          loading={integrationDataLoading}/>:
                activeTab=='add'?<IntegrationsAdd empushyIntegrations={empushyIntegrations} activeIntegrations={activeIntegrations}
                                                  userDetails={userDetails}/>:
                  activeTab=='HubSpot'?<div><IntegrationDetail selectedIntegration={selectedIntegration} userDetails={userDetails} authToken={authToken}
                                                               activityData={activityData} analysisData={analysisData}/></div>:
                    activeTab=='Intercom'?<div><IntegrationDetail selectedIntegration={selectedIntegration} userDetails={userDetails} authToken={authToken}/></div>:''
            }

            {/*<div>

               Cards 1 (Trending apps)
              <div className="mt-8">
                <h2 className="text-xl text-gray-800 font-bold mb-5">Trending apps</h2>
                <div className="grid grid-cols-12 gap-6">
                {
                  items01.map(item => {
                    return (
                      <ApplicationsCard01
                        key={item.id}
                        id={item.id}
                        image={item.image}
                        title={item.title}
                        link={item.link}
                        content={item.content}
                        rating={item.rating}
                        feat01={item.feat01}
                        feat02={item.feat02}
                        feat03={item.feat03}
                        feat04={item.feat04}
                      />
                    )
                  })
                }
                </div>
              </div>

               Cards 2 (Premium but worth it)
              <div className="mt-8">
                <h2 className="text-xl text-gray-800 font-bold mb-5">Premium but worth it</h2>
                <div className="grid grid-cols-12 gap-6">
                {
                  items02.map(item => {
                    return (
                      <ApplicationsCard02
                        key={item.id}
                        id={item.id}
                        image={item.image}
                        title={item.title}
                        link={item.link}
                        content={item.content}
                        rating={item.rating}
                        price={item.price}
                        deal={item.deal}
                      />
                    )
                  })
                }
                </div>
              </div>

               Cards 3 (Popular categories)
              <div className="mt-8">
                <h2 className="text-xl text-gray-800 font-bold mb-5">Popular categories</h2>
                <div className="grid grid-cols-12 gap-6">
                {
                  items03.map(item => {
                    return (
                      <ApplicationsCard03
                        key={item.id}
                        id={item.id}
                        image={item.image}
                        title={item.title}
                        link={item.link}
                      />
                    )
                  })
                }
                </div>
              </div>

            </div>*/}

          </div>
          <AlertModal params={alertModalState} toggleState={setAlertModalState}/>
        </main>

      </div>
    </div>
  ):(
    <div></div>
  );
}

export default Integrations;